import { NgModule } from '@angular/core';
import { RouterModule, Routes, provideRouter, withComponentInputBinding } from '@angular/router';

import { FinancingStartComponent } from './pages/financing-start/financing-start.component';
import { PrivacySettingsComponent } from './pages/privacy-settings/privacy-settings.component';

import { IdentificationComponent } from './pages/steps/identification/identification.component';
import { CoHolderComponent } from './pages/co-holder/co-holder.component';
import { PersonalDataInfoComponent } from './pages/steps/personal-data/personal-data-info/personal-data-info.component';
import { PersonalDataBirthComponent } from './pages/steps/personal-data/personal-data-birth/personal-data-birth.component';
import { ContactDataInfoComponent } from './pages/steps/contact-data-info/contact-data-info.component';

import { AccessDeniedComponent } from './access/access-denied/access-denied.component';
import { LoginComponent } from './access/login/login.component';
import { HouseTypeComponent } from './pages/steps/housing/house-type/house-type.component';
import { ContractTypeComponent } from './pages/steps/professional-data/contract-type/contract-type.component';
import { AdditionalDataFirstComponent } from './pages/steps/additional-data/additional-data-first/additional-data-first.component';
import { AdditionalDataSecondComponent } from './pages/steps/additional-data/additional-data-second/additional-data-second.component';
import { LoanComponent } from './pages/steps/additional-data/additional-data-loan/additional-data-loan.component';
import { SecureFinancingComponent } from './pages/steps/secure-financing/secure-financing.component';
import { CoOperatorComponent } from './pages/steps/co-operator-old/co-operator.component';
import { SorryComponent } from './pages/sorry/sorry.component';
import { PreauthorizedComponent } from './pages/preauthorized/preauthorized.component';
import { HouseAddressComponent } from './pages/steps/housing/house-address/house-address.component';
import { WorkingSituationComponent } from './pages/steps/professional-data/working-situation/working-situation.component';

import { BankDetailsComponent } from './pages/steps/bank-details/bank-details.component';
import { RecruitmentComponent } from './pages/steps/recruitment/recruitment.component';
import { AuthenticationComponent } from './pages/steps/authentications/authentication/authentication.component';
import { DocumentationComponent } from './pages/steps/documentation/documentation.component';
import { AuthenticationDataComponent } from './pages/steps//authentications/authentication-data/authentication-data.component';

const routes: Routes = [
    { path: 'access/:token', component: LoginComponent },
    { path: 'access-denied', component: AccessDeniedComponent },

    { path: 'main/financing-start', component: FinancingStartComponent },
    { path: 'main/privacy-settings', component: PrivacySettingsComponent },

    { path: 'main/step/identification', component: IdentificationComponent },
    { path: 'main/step/personal-data-info', component: PersonalDataInfoComponent },
    { path: 'main/step/personal-data-birth', component: PersonalDataBirthComponent },
    { path: 'main/step/contact-data-info', component: ContactDataInfoComponent },
    { path: 'main/step/house-address', component: HouseAddressComponent },
    { path: 'main/step/house-type', component: HouseTypeComponent },
    { path: 'main/step/working-situation', component: WorkingSituationComponent },
    { path: 'main/step/contract-type', component: ContractTypeComponent },//-FALTA
    { path: 'main/step/additional-data-first', component: AdditionalDataFirstComponent },
    { path: 'main/step/additional-data-second', component: AdditionalDataSecondComponent },
    { path: 'main/step/additional-data-loan', component: LoanComponent },//-FALTA

    { path: 'main/secure-financing', component: SecureFinancingComponent },
    { path: 'main/preauthorized', component: PreauthorizedComponent },

    { path: 'main/step/bank-details', component: BankDetailsComponent },
    { path: 'main/step/recruitment', component: RecruitmentComponent },
    { path: 'main/step/authentications/authentication', component: AuthenticationComponent },
    { path: 'main/step/authentications/authentication-data', component: AuthenticationDataComponent },
    { path: 'main/step/documentation', component: DocumentationComponent },

    { path: 'main/co-holder', component: CoHolderComponent },//-Falta incluir en routing
    /* Este es el co-holder
    { path: 'main/step/co-operator', component: CoOperatorComponent },
 */
    { path: 'main/sorry', component: SorryComponent },

    { path: '', redirectTo: '/main/financing-start', pathMatch: 'full' },
    { path: '**', redirectTo: '/main/financing-start' },
];

@NgModule({
    providers: [provideRouter(routes, withComponentInputBinding())],
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LayoutRoutingModule {}
